import { StrictMode, useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import CurrentLocation from '../../components/current-location/current-location';
import LoadingAnimation from '../../components/loading-animation/loading-animation';
import LocationDropdown from '../../components/location-dropdown/location-dropdown';
import RedirectNotificationBar from '../../components/redirect-notification-bar/redirect-notification-bar';
import useGetUserLocation from '../../services/useGetUserLocation';
import UseGetWordPressData from '../../services/useWordPressData';
import ErrorBoundary from '../../utils/errorBoundary';

const rootElement = document.getElementById('location-redirect-react');

const UserLocationRedirect = () => {
	const loggedInCheck = UseGetWordPressData('check_if_logged_in');
	const getCurrentLocation = UseGetWordPressData('get_current_location');
	const getLocations = UseGetWordPressData('get_location_dropdowns');
	const userLocationData = useGetUserLocation();
	const [loggedIn, setLoggedIn] = useState(false);
	const [locations, setLocations] = useState(null);
	const [showRedirectMessage, setShowRedirectMessage] = useState(false);
	const [currentLocation, setCurrentLocation] = useState(null);
	const [userLocation, setUserLocation] = useState(null);
	const [isLocationsOpen, setIsLocationsOpen] = useState(false);

	// Check if the user is logged in
	useEffect(() => {
		if (loggedInCheck.success) {
			setLoggedIn(loggedInCheck.data);
		}
	}, [loggedInCheck]);

	// Get the user's location if not logged in
	useEffect(() => {
		if (!loggedIn && userLocationData.success) {
			setUserLocation(userLocationData.data);
		}
	}, [loggedIn, userLocationData]);

	// Get current site location
	useEffect(() => {
		if (getCurrentLocation.success) {
			setCurrentLocation(getCurrentLocation.data);
		}
	}, [getCurrentLocation]);

	// Get location dropdown information
	useEffect(() => {
		if (getLocations.success) {
			setLocations(getLocations.data);
		}
	}, [getLocations]);

	// Show redirect notification if needed
	useEffect(() => {
		if (
			userLocation?.country_code &&
			currentLocation?.country_code &&
			userLocation.country_code !== currentLocation.country_code &&
			userLocation.redirect_message &&
			sessionStorage.getItem('redirect_notification') !== 'true'
		) {
			setShowRedirectMessage(true);
		}
	}, [userLocation, currentLocation]);

	// Set session storage to prevent duplicate notifications
	useEffect(() => {
		if (showRedirectMessage) {
			sessionStorage.setItem('redirect_notification', 'true');
		}
	}, [showRedirectMessage]);

	const toggleLocationsClass = () => {
		setIsLocationsOpen((prevState) => !prevState);
	};

	if (!currentLocation || !locations) {
		return (
			<>
				<LoadingAnimation type="lang"></LoadingAnimation>
			</>
		);
	}

	return (
		<StrictMode>
			<>
				<button
					onClick={toggleLocationsClass}
					className={`locations${
						isLocationsOpen ? ' locations--open' : ''
					}`}
				>
					<CurrentLocation
						country_code={currentLocation.country_code}
						language={currentLocation.language}
						flag_URL={currentLocation.flag_URL}
					></CurrentLocation>
					<LocationDropdown locations={locations}></LocationDropdown>
				</button>
				{showRedirectMessage && userLocation && (
					<RedirectNotificationBar
						type="redirect"
						site_url={userLocation.site_url}
						current_country_code={userLocation.country_code}
						current_language={userLocation.language}
						current_flag_URL={userLocation.flag_URL}
						redirect_message={userLocation.redirect_message}
						locations={locations}
					/>
				)}
			</>
		</StrictMode>
	);
};

export default UserLocationRedirect;

if (rootElement) {
	ReactDOM.createRoot(rootElement).render(
		<ErrorBoundary>
			<UserLocationRedirect />
		</ErrorBoundary>
	);
}
